import { useIntl } from "react-intl";

type GoAiguaTextInputType = {
    placeholder?: string;
    text: string;
    onChange?: (e: any) => any;
    onBlur?: (e: any) => any;
    className?: string;
    type?: string;
    id?: string;
    label?: string;
    maxLength?: number;
};

const GoAiguaTextInput = ({
    placeholder = "",
    onChange,
    onBlur,
    text,
    className = "",
    type = "string",
    id,
    label,
    maxLength,
}: GoAiguaTextInputType) => {
    return (
        <div className={"c-goaigua-textinput"}>
            {label ? (
                <label className="c-goaigua-textinput__label" htmlFor={id}>
                    {label}
                </label>
            ) : null}

            <input
                type={type}
                placeholder={placeholder}
                onChange={onChange ? (e) => onChange(e.target.value) : void 0}
                onBlur={onBlur}
                className={className}
                value={text}
                id={id}
                maxLength={maxLength}
                autoComplete={"off"}
            />
        </div>
    );
};

export default GoAiguaTextInput;
